import { JSONSchemaType } from 'ajv';
import { FormInfo } from '../types';
import LongTextField from './styledUniforms/src/LongTextField';
import FileField from './styledUniforms/FileField';
import BoolField from './styledUniforms/src/BoolField';
import HiddenField from './styledUniforms/src/HiddenField';
import WysiwygField from './styledUniforms/src/WysiwygField';

export default function schemaBuilder(formInfo: FormInfo): {
  schema: JSONSchemaType<FormProperties>;
  fieldLabels: Record<string, string>;
} {
  const requiredFields: Array<string> = [];
  const fieldLabels: Record<string, string> = {};

  const properties = formInfo.fields.reduce(
    (acc, { file_extension, label, name, required, type, selectValues, value, wysiwyg }, index) => {
      const options = type === 'select' ? { enum: selectValues.map((v) => v.value) } : {};

      let field = { type: 'string', maxLength: 2000, ...options } as SchemaFieldType;

      switch (type) {
        case 'textarea': {
          field = {
            ...field,
            uniforms: { component: LongTextField },
          };
          break;
        }
        case 'checkbox': {
          field = {
            ...options,
            type: 'boolean',
            uniforms: { component: BoolField },
          };
          break;
        }
        case 'hidden': {
          const uniforms =
            formInfo.defaultHiddenValue && name !== 'form-url'
              ? { component: HiddenField, value: formInfo.defaultHiddenValue }
              : { component: HiddenField, value };
          field = {
            ...field,
            uniforms,
          };

          if (formInfo.defaultHiddenValue && name !== 'form-url') {
            formInfo.fields[index].value = formInfo.defaultHiddenValue;
          }
          break;
        }
        case 'email': {
          field = {
            ...field,
            format: 'email',
          };
          break;
        }
        case 'file': {
          const fileUploadRequired = required ? { required: ['size'] } : {};
          field = {
            ...options,
            ...{
              type: 'object',
              properties: {
                name: { type: 'string' },
                size: { type: 'number', minimum: 1 },
                type: { type: 'string' },
              },
              ...fileUploadRequired,
            },
            uniforms: { component: FileField, fileExtension: file_extension || '' },
          };
          break;
        }
        case 'wysiwyg': {
          field = {
            ...field,
            uniforms: { component: WysiwygField, value: wysiwyg || '' },
          };
          break;
        }
      }

      field = {
        ...field,
        uniforms: { ...field.uniforms, label },
      };
      fieldLabels[name] = label;

      if (name) {
        if (required && type !== 'wysiwyg' && type !== 'hidden') {
          requiredFields.push(name);
        }
        return { ...acc, [name]: field };
      }
      return acc;
    },
    {},
  );

  const schema = {
    title: formInfo.title,
    type: 'object',
    properties: {
      ...properties,
    },
    required: requiredFields,
  } as JSONSchemaType<FormProperties>;

  return { schema, fieldLabels };
}
